export default __webpack_public_path__ + "static/media/hand-splash-mobile.db2abe48.png";